// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { productCompareFlyOutStyles } from "@west/Overrides/Components/ProductCompareFlyOut";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

productCompareFlyOutStyles.carouselDrawer = {
    position: "bottom",
    cssOverrides: {
        scrim: css`
            transition: 300ms ease-in-out;
            background: transparent;
            z-index: 1311;
        `,
        drawerTitle: css`
            display: none;
        `,
        drawerContent: css`
            background-color: transparent;
            overflow-y: hidden;
            ${xScreen("lte", "xs")} {
                height: 100%;
            }
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

productCompareFlyOutStyles.carouselDrawerContainer = {
    css: css`
        padding: 25px 0;
        background: ${color("common.white")};
        box-shadow: 0 0 4px 0 ${color("common.ui7", 0.3)};
        ${xScreen("lte", "md")} {
            padding: 18px 0;
        }
        ${xScreen("lte", "xs")} {
            height: 100%;
        }
    `,
};

productCompareFlyOutStyles.carouselDrawerPage = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
        &&& {
            padding: 0;
            background: inherit;
        }
    `,
};

productCompareFlyOutStyles.removeProductFromCompareButton = {
    css: css`
        position: absolute;
        right: 4px;
        top: 4px;
        padding: 8px;
        border-radius: 50%;
        transition: all ease-in-out ${getProp("theme.transition.duration.regular")}ms;
        &:hover {
            background-color: ${color("common.ui4", 0.6)};
        }
    `,
};

productCompareFlyOutStyles.headerRemoveAllButton = {
    variant: "tertiary",
    css: css`
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

productCompareFlyOutStyles.headerCompareButton = {
    css: css`
        margin-bottom: 15px;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

productCompareFlyOutStyles.compareHeaderStyles = {
    container: {
        css: css`
            &&& {
                padding: 0 20px;
            }
            height: 36px;
            background-color: transparent;
        `,
    },
    titleText: {
        size: 16,
        weight: "bold",
        color: "common.white",
        css: css`
            letter-spacing: 0;
            line-height: 18px;
        `,
    },
    toggle: {
        css: css`
            display: flex;
            gap: 10px;
            align-items: center;
            justify-content: center;
            padding: 6px 25px;
            background: ${color("primary")};
            border-radius: 3px 3px 0 0;
            &:focus {
                outline: none;
            }
        `,
    },
    icon: {
        size: 24,
        color: "common.white",
    },
};

productCompareFlyOutStyles.actionsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 40px;
        ${xScreen("lte", "md")} {
            padding: 10px 40px;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            overflow: hidden;
            max-width: 500px;
        }
    `,
};

productCompareFlyOutStyles.slidesWrapper = {
    css: css`
        display: none;
        width: 100%;
        padding: 10px;
        ${xScreen("gt", "lg")} {
            display: flex;
            gap: 14px;
            justify-content: center;
        }
    `,
};

productCompareFlyOutStyles.slideItem = {
    css: css`
        width: 120px;
        height: 120px;
        scroll-snap-align: start;
    `,
};
